import { ProjectMembership } from './project-membership.entity';
import { UserSkill } from '@entities/user-skill.entity';

export class User {
    id?: number;
    azureId?: string;
    token?: string;
    email?: string;
    name?: string;
    isGuest?: boolean;
    isAdmin?: boolean;
    icon?: string;
    mobilePhone?: string;
    jobTitle?: string;
    personalDescription?: string;

    projectMemberShip?: ProjectMembership[];
    userSkills?: UserSkill[];

    _language? = 'en';
    _image?: string;
    _topSkills?: UserSkill[];
    _firstName?: string;
    _lastName?: string;
}
